import script from "./PbxDeviceRegisterModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PbxDeviceRegisterModal.vue?vue&type=script&setup=true&lang=js"

import "./PbxDeviceRegisterModal.vue?vue&type=style&index=0&id=19c6cdc6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19c6cdc6"]])

export default __exports__